import {
  ESendMessageActionTypes,
  IDeleteMessagePayload,
  IMarkMessageAsDeletedPayload,
  IRestoreMessagePayload,
  ISendFirstMessagePayload,
  ISendMessagePayload,
} from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Не удалось отправить сообщение на стороне клиента
 */
export const setSendMessageFailed = actionGenerator<ESendMessageActionTypes.SetFailed, ISendMessagePayload>(
  ESendMessageActionTypes.SetFailed,
);

/**
 * Удачная отправка сообщения
 */
export const setSendMessageSuccess = actionGenerator<ESendMessageActionTypes.SetSuccess, ISendMessagePayload>(
  ESendMessageActionTypes.SetSuccess,
);

/**
 * Удачная отправка первого сообщения
 */
export const setSendFirstMessageSuccess = actionGenerator<
  ESendMessageActionTypes.SetFirstMessageSuccess,
  ISendFirstMessagePayload
>(ESendMessageActionTypes.SetFirstMessageSuccess);

/**
 * Ожидание отправки сообщения
 */
export const setSendMessagePending = actionGenerator<ESendMessageActionTypes.SetPending, ISendMessagePayload>(
  ESendMessageActionTypes.SetPending,
);

/**
 * Удаление сообщения из чата
 */
export const deleteMessageFromChat = actionGenerator<
  ESendMessageActionTypes.DeleteMessageFromChat,
  IDeleteMessagePayload
>(ESendMessageActionTypes.DeleteMessageFromChat);

/**
 * Пометка сообщения как удалённого
 */
export const markMessageAsDeleted = actionGenerator<
  ESendMessageActionTypes.MarkMessageAsDeleted,
  IMarkMessageAsDeletedPayload
>(ESendMessageActionTypes.MarkMessageAsDeleted);

/**
 * Восстановление сообщения при откате после оптимистичного обновления
 */
export const restoreMessage = actionGenerator<ESendMessageActionTypes.RestoreMessage, IRestoreMessagePayload>(
  ESendMessageActionTypes.RestoreMessage,
);
